var app = {
  error: 'Es ist ein Fehler aufgetreten',
  networkError: 'Netzwerk Fehler',
};
